import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { GuiMsjService } from '../shared/gui-msj.service';
import { environment } from 'src/environments/environment';
import { Response } from 'src/app/interfaces/interface-bakend/response';
import { Provincia } from '@interfaces/interface-bakend/provincias/provincias.interface';
import Swal from 'sweetalert2';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class ProvinciaService {
    
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private guiMsjService: GuiMsjService,
        private authService: AuthService
    ) {}

    async findAll(): Promise<Provincia[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .get<Response>(`${URL_BACKEND}/provincias/findAll`, { headers })
                .subscribe(
                    (resp: Response) => {
                        Swal.close();
                        resolve(resp.response);
                    },
                    (error) => {
                        console.error(error);
                        this.guiMsjService.msjFormSubmit('errorCargarProvincias');
                        this.router
                            .navigateByUrl('/', { skipLocationChange: true })
                            .then(async () => {
                                await this.router.navigateByUrl('/');
                            });
                        reject(error);
                    }
                );
        });
    }

    async findOne(_id: string): Promise<Provincia> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .get<Response>(`${URL_BACKEND}/provincias/findOne/${_id}`, { headers })
                .subscribe(
                    (resp: Response) => {
                        Swal.close();
                        resolve(resp.response);
                    },
                    (error) => {
                        console.error(error);
                        this.guiMsjService.msjFormSubmit('errorCargarProvincia');
                        reject(error);
                    }
                );
        });
    }

    async createProvinciaSilent(provincia: any): Promise<Provincia> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .post<Provincia>(`${URL_BACKEND}/provincias/create`, provincia, { headers })
                .subscribe(
                    (resp) => resolve(resp),
                    (error) => reject(error)
                );
        });
    }
}